import React from 'react';
import { useCreateOperator } from '../../../contexts/CreateOperatorContext';

export const ResultsHeader = () => {
  const { operator } = useCreateOperator();

  return (
    <div className="block p-2 text-center">
      <h1 className="text-4xl">Creating Operator</h1>
      <p className="text-lg opacity-70">
        {operator.name} ({operator.code})
      </p>
    </div>
  );
};
